import { TOrderAttributeTypes, TRESPONSE_ORDER_ATTRIBUTES } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';

export const ORDER_ATTRIBUTES_TABLE_MODEL = {
  createModel: (items: TRESPONSE_ORDER_ATTRIBUTES['records'], attributeType: TOrderAttributeTypes = 'PRODUCT_TYPE') => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        ...(attributeType === 'PRODUCT_TYPE' && {
          select: {
            position: 'START',
            isMulti: true,
            size: 'DEFAULT',
          },
        }),
        edit: {
          hasAddRow: true,
          hasDeleteRow: true,
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'ID',
            isHidden: true,
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value) => value.id,
              },
              metadata: {
                keyName: 'id',
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'NAME',
            widthInPx: 200,
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value) => value.name,
              },
              metadata: {
                keyName: 'name',
                isRequired: true,
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'CODE',
            widthInPx: 200,
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value) => value.code,
              },
              metadata: {
                keyName: 'code',
                isRequired: true,
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'DESCRIPTION',
            widthInPx: 200,
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value) => value.desc,
              },
              metadata: {
                keyName: 'desc',
              },
            },
          },
        ],
      },
      (item): TTableRowNode<TRESPONSE_ORDER_ATTRIBUTES['records'][number]> => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.id,
            },
            {
              type: 'TEXT_CELL',
              text: item.name,
            },
            {
              type: 'TEXT_CELL',
              text: item.code,
            },
            {
              type: 'TEXT_CELL',
              text: item.desc,
            },
          ],
        };
      },
    );
  },
};
